import type { Page } from '@webapp/account/src/resources/common';
import type { States } from '@webapp/account/src/resources/states';

import type { LogicCondition } from '@webapp/common/entities/logic';
import type { Question } from '@webapp/common/resources/entities/question';

import type { Link, LogicLinkParamsState } from './links';

export const selectLogicLinkParams = ({ LogicLinkParams }: States): LogicLinkParamsState => LogicLinkParams;

export const selectLogicLinkParamsList = (states: States): Array<Link> => {
    const l = selectLogicLinkParams(states);

    return l.items;
};

export const selectIsLogicLinkParamsLoadedOrLoading = (states: States): boolean => {
    const l = selectLogicLinkParams(states);

    return l.linkParamsLoaded || l.linkParamsLoading;
};

export const selectLogicLinkParamsConditionsList = (states: States): Array<LogicCondition> => {
    const l = selectLogicLinkParams(states);

    return l.logics;
};

export const selectLogicLinkParamsPagesAndQuestionsList = (
    states: States,
): { pages: Array<Page>; questions: Array<Question> } => {
    const l = selectLogicLinkParams(states);

    return { pages: l.pages, questions: l.questions };
};

export const getConditionById = (states: States, conditionId: number): LogicCondition => {
    const l = selectLogicLinkParams(states);
    return l.logics.find((l) => l.id === conditionId);
};
